var _rect, _rect2, _rect3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessManagementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E9E9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.93433,
    y: 5.43921,
    width: 69.0942,
    height: 69.0942,
    rx: 34.5471,
    fill: "#E9E9E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.93433,
    y: 5.43921,
    width: 69.0942,
    height: 69.0942,
    rx: 34.5471,
    stroke: "white",
    strokeWidth: 1.97412
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0918 46.928H55.697V44.6104C55.697 43.586 55.29 42.6036 54.5657 41.8793C53.8413 41.155 52.8589 40.748 51.8346 40.748C50.8102 40.748 49.8278 41.155 49.1035 41.8793C48.3791 42.6036 47.9722 43.586 47.9722 44.6104V46.928H47.5774C46.8633 46.9333 46.1803 47.2204 45.6771 47.727C45.1738 48.2336 44.8911 48.9185 44.8906 49.6326V55.0397C44.8911 55.7569 45.1762 56.4445 45.6833 56.9516C46.1904 57.4586 46.878 57.7437 47.5952 57.7443H56.0839C56.801 57.7437 57.4887 57.4586 57.9957 56.9516C58.5028 56.4445 58.7879 55.7569 58.7885 55.0397V49.6326C58.7879 48.9168 58.5039 48.2304 57.9985 47.7235C57.4931 47.2167 56.8076 46.9307 56.0918 46.928ZM50.2978 44.6104C50.3121 44.2103 50.4811 43.8313 50.7692 43.5533C51.0573 43.2753 51.4421 43.1199 51.8425 43.1199C52.2429 43.1199 52.6277 43.2753 52.9158 43.5533C53.2039 43.8313 53.3729 44.2103 53.3872 44.6104V46.928H50.2978V44.6104Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5724 49.6316C42.5735 48.6406 42.8673 47.6719 43.4169 46.8472C43.9666 46.0226 44.7476 45.3787 45.6619 44.9964V44.6015C45.6662 43.6943 45.8726 42.7994 46.266 41.9819C45.0593 41.1744 43.6394 40.7448 42.1875 40.7481H29.0536C27.1083 40.7507 25.2434 41.5246 23.8679 42.9002C22.4924 44.2757 21.7184 46.1406 21.7158 48.0859V53.493C21.7158 53.8003 21.8379 54.0951 22.0552 54.3124C22.2725 54.5297 22.5673 54.6518 22.8746 54.6518H42.5724V49.6316Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.344 29.9347C43.344 31.4625 42.891 32.956 42.0422 34.2263C41.1934 35.4967 39.9869 36.4868 38.5754 37.0714C37.1639 37.6561 35.6107 37.8091 34.1123 37.511C32.6138 37.2129 31.2374 36.4772 30.157 35.3969C29.0767 34.3166 28.341 32.9402 28.043 31.4417C27.7449 29.9433 27.8979 28.3901 28.4825 26.9786C29.0672 25.5671 30.0573 24.3606 31.3276 23.5118C32.598 22.663 34.0915 22.21 35.6193 22.21C37.668 22.21 39.6328 23.0238 41.0815 24.4725C42.5302 25.9212 43.344 27.886 43.344 29.9347Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManagementIcon);
export default __webpack_public_path__ + "static/media/accessManagementIcon.174340ee9e1035db4da83ece563c1279.svg";
export { ForwardRef as ReactComponent };